












































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import FaqCategoryDto from '@/models/FaqCategories/FaqCategoryDto'
import FaqCategoryEdit from '@/components/FaqCategories/FaqCategoryEdit.vue';
import FaqCategoryCreate from '@/components/FaqCategories/FaqCategoryCreate.vue';
import FaqArticles from '@/components/FaqArticles/FaqArticles.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'FaqCategory',
  components: { FaqCategoryEdit, FaqCategoryCreate, FaqArticles }
})
export default class extends GiganautVue {
    
    async beforeMount() {
        AgencySettingsModule.updateCurrentFaqCategory(null);
    }

    async updateCurrentFaqCategory(faqCategory: FaqCategoryDto) {
        AgencySettingsModule.updateCurrentFaqCategory(faqCategory);
    }

    get currentFaqCategory() {
        return AgencySettingsModule.currentFaqCategory;
    }

    get loading() {
        return AgencySettingsModule.loadingFaqCategories;
    }

    get faqCategories() {
        return AgencySettingsModule.faqCategories;
    }

    async deleteFaqCategory(faqCategory: FaqCategoryDto) {
        const options: VuetifyConfirmObject = {
                buttonTrueText: "DELETE",
                buttonFalseText: "CANCEL",
                buttonTrueColor: "primary",
                buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the faq category ' + faqCategory.name + '?', options);
        // if (result) {
        //     const request = new UpdateAgencyUserStatusRequest();
        //     request.updatedAt = user.updatedAt;
        //     request.status = AgencyUserStatusEnum.Deleted;
        //     await AgencySettingsModule.deleteAgencyUser(request);
        // }
  }
}
